import React from 'react';
import {
  PANEL_WIDTH_DEFAULT,
  clampPanelWidth,
  getMaxPanelWidth,
  readStoredPanelWidth,
  writeStoredPanelWidth,
} from './panel-resize';

export function usePersistedPanelWidth(
  storageKey: string,
  defaultWidth: number = PANEL_WIDTH_DEFAULT,
) {
  const [panelWidth, setPanelWidthState] = React.useState<number>(() => {
    const stored = readStoredPanelWidth(storageKey);
    if (stored !== null) return clampPanelWidth(stored);
    return clampPanelWidth(defaultWidth);
  });

  const setPanelWidth = React.useCallback(
    (width: number) => {
      const clamped = clampPanelWidth(width, getMaxPanelWidth());
      setPanelWidthState(clamped);
      writeStoredPanelWidth(storageKey, clamped);
    },
    [storageKey]
  );

  React.useEffect(() => {
    const handleResize = () => {
      setPanelWidthState(w => clampPanelWidth(w));
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return { panelWidth, setPanelWidth };
}
